/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
import { Tabs } from "antd";
import { BillContainerStyles } from "./BillsContainerStyles";
import { TabList } from "./BillsContainerConstants";
import useRedirect from "../../helperHooks/useRedirect";

const { TabPane } = Tabs;

interface Props {
  currentTab: string;
}

const BillsContainer: React.FC<Props> = (props: Props) => {
  const { currentTab } = props;
  const redirect = useRedirect();
  const handleTabChange = (key: string) => {
    if (key === "1") {
      redirect(routes => routes.bills.upload);
    } else {
      redirect(routes => routes.bills.new);
    }
  };
  return (
    <div css={BillContainerStyles} className="mt-4">
      <Tabs
        defaultActiveKey="1"
        activeKey={currentTab}
        onChange={handleTabChange}
      >
        <TabPane tab={TabList.UtilizeMoney} key="1" />
        <TabPane tab={TabList.History} key="2" />
      </Tabs>
    </div>
  );
};

export default BillsContainer;
